import styled, { css } from 'styled-components';

import { breakpointDown } from '/shared/styled/Breakpoints';

interface Props {
  $primary?: boolean;
  $maxHeight?: string | null;
  $jumbo?: boolean;
  $stretch?: boolean;
  $icon?: boolean;
  $isColumn?: boolean;
}

function jumboStyle({ $jumbo = false, $isColumn = false }: Props) {
  if ($jumbo) {
    return css`
      ${
        $isColumn &&
        css`
        min-height: 2.75rem;
      `
      }
      ${breakpointDown('mobile')} {
        img {
          width: 17.5vw;
          max-width: 4rem;
          max-height: 2rem;
        }
      }
    `;
  }
}

function iconStyle({ $primary = false, $jumbo = false, $stretch = false, $icon = false }: Props) {
  if ($primary && !$jumbo && $icon) {
    return css`
      position: absolute;
      left: 1rem;
      transform: translateY(-50%);
      top: 50%;
      ${
        $stretch &&
        css`
        left: 0;
      `
      }
    `;
  }
}

function maxHeightStyle({ $maxHeight = null }: Props) {
  if ($maxHeight) {
    return css`
      img {
        max-height: ${$maxHeight};
      }
    `;
  }
}

export default styled.span<Props>`

  img {
    pointer-events: none;
    cursor: pointer;
  }
  ${maxHeightStyle}
  ${jumboStyle}
  ${iconStyle}
`;
